// hooks/useUpdatePersonalInfo.js
import { useState } from 'react';
import updatePersonalInfo from '../data/updatePersonalInfo';
import { useNotify } from '../context/NotificationContext';

export default function useUpdatePersonalInfo(token) {
  const [updating, setUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  const [success, setSuccess] = useState(false);
  const notify = useNotify();

  const updateSettings = async (newSettings) => {
    setUpdating(true);
    setUpdateError(null);
    setSuccess(false);

    try {
      const result = await updatePersonalInfo(token, newSettings);
      setSuccess(true);
      const smsStatus = result?.success?.smsStatus;
      console.log('SMSSTATUS', smsStatus);
      let msg;
      switch (smsStatus) {
        case 'missing_phone':
          notify.show(
            'Profile saved. SMS settings were not updated\n[missing phone].'
          );
          break;

        case 'invalid_phone':
          notify.show(
            'Profile saved. SMS settings were not updated\n[invalid phone].'
          );
          break;

        case 'phone_already_used':
          notify.show(
            'Profile saved. SMS settings were not updated\n[phone already in use].'
          );
          break;

        default:
          notify.show('Profile settings saved');
      }
      return result;
    } catch (err) {
      console.error('Failed to update profile settings:', err);
      notify.show('Failed to update profile settings');
      setUpdateError(err);
      throw err;
    } finally {
      setUpdating(false);
    }
  };

  return { updateSettings, updating, updateError, success };
}
